import React from "react";
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from "@mui/material";
import { useProfile } from "../../../common/useProfile";
export default function MainMenuComp(props) {
    const {item, action, style} = props;
    const [show, setShow] = React.useState(false);
    const prof = useProfile();

    React.useEffect(() =>{
        if( prof.isOk && item && item.data.mainMenu ){
            const page = localStorage.getItem("pageRoot");
            const pagejs = JSON.parse(page);
            if (pagejs.layout ){
                const left = pagejs.layout.left;
                
                if( left.regra && left.regra.length > 1 ){
                    setShow( prof.temAcesso(left.regra) );
                    // setShow( true );
                }else{
                    setShow( true );
                }
            }else{
                setShow( true )
            }
        }
    },[item, prof.isOk])

    function handleDrawerOpen(e){
        if(action )action(e);
    }

    if( !show) return;

    return (
        <React.Fragment>
            <IconButton
                size="large"
                edge="start"
                color="inherit"
                // color="primary"
                aria-label="open drawer"
                sx={style != null? style:{ mr: 2 }}
                onClick={handleDrawerOpen}
            >
                <MenuIcon />
            </IconButton>
        </React.Fragment>
    )
}